import React, { Component } from 'react';
import { SectionHeader } from '../components/shared/SectionHeader';
import { AnimatedSection } from '../components/shared/AnimatedSection';
import { CheckCircle, ClipboardCheck, FileCheck, Settings } from 'lucide-react';
export function QAQCPage() {
  return <div className="min-h-screen pt-20" data-id="element-459">
      <SectionHeader title="Quality Assurance & Quality Control" subtitle="Ensuring excellence through rigorous quality management systems" data-id="element-460" />

      <section className="py-20" data-id="element-461">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-462">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-463">
            <AnimatedSection data-id="element-464">
              <div className="bg-white p-8 rounded-lg shadow-lg border-l-4 border-gold" data-id="element-465">
                <CheckCircle size={48} className="text-gold mb-4" data-id="element-466" />
                <h3 className="text-2xl font-bold text-charcoal mb-4" data-id="element-467">
                  Quality Assurance (QA)
                </h3>
                <p className="text-stone mb-4" data-id="element-468">
                  Preventive approach ensuring quality is built into processes
                </p>
                <ul className="space-y-2 text-stone" data-id="element-469">
                  <li data-id="element-470">• Process planning and documentation</li>
                  <li data-id="element-471">• Standards compliance</li>
                  <li data-id="element-472">• Training and competency</li>
                  <li data-id="element-473">• Continuous improvement</li>
                </ul>
              </div>
            </AnimatedSection>

            <AnimatedSection data-id="element-474">
              <div className="bg-white p-8 rounded-lg shadow-lg border-l-4 border-deep-blue" data-id="element-475">
                <ClipboardCheck size={48} className="text-deep-blue mb-4" data-id="element-476" />
                <h3 className="text-2xl font-bold text-charcoal mb-4" data-id="element-477">
                  Quality Control (QC)
                </h3>
                <p className="text-stone mb-4" data-id="element-478">
                  Detective approach verifying quality through inspection
                </p>
                <ul className="space-y-2 text-stone" data-id="element-479">
                  <li data-id="element-480">• Material testing and inspection</li>
                  <li data-id="element-481">• Workmanship verification</li>
                  <li data-id="element-482">• Non-conformance management</li>
                  <li data-id="element-483">• Final acceptance testing</li>
                </ul>
              </div>
            </AnimatedSection>
          </div>

          <AnimatedSection data-id="element-484">
            <div className="bg-gradient-to-br from-gray-50 to-white p-12 rounded-lg shadow-lg" data-id="element-485">
              <div className="flex items-center gap-4 mb-8" data-id="element-486">
                <Settings size={48} className="text-gold" data-id="element-487" />
                <h3 className="text-3xl font-bold text-charcoal" data-id="element-488">
                  Our QA/QC Framework
                </h3>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-489">
                <div data-id="element-490">
                  <h4 className="font-bold text-charcoal mb-4 flex items-center gap-2" data-id="element-491">
                    <FileCheck className="text-gold" data-id="element-492" />
                    Key Components
                  </h4>
                  <ul className="space-y-2 text-stone" data-id="element-493">
                    <li data-id="element-494">• ISO-aligned quality management systems</li>
                    <li data-id="element-495">• Comprehensive testing protocols</li>
                    <li data-id="element-496">• Material sourcing and verification</li>
                    <li data-id="element-497">• Vendor quality management</li>
                    <li data-id="element-498">• Documentation and traceability</li>
                  </ul>
                </div>
                <div data-id="element-499">
                  <h4 className="font-bold text-charcoal mb-4 flex items-center gap-2" data-id="element-500">
                    <CheckCircle className="text-gold" data-id="element-501" />
                    Benefits
                  </h4>
                  <ul className="space-y-2 text-stone" data-id="element-502">
                    <li data-id="element-503">• Consistent quality delivery</li>
                    <li data-id="element-504">• Reduced rework and waste</li>
                    <li data-id="element-505">• Enhanced client satisfaction</li>
                    <li data-id="element-506">• Regulatory compliance</li>
                    <li data-id="element-507">• Continuous improvement culture</li>
                  </ul>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </div>;
}